import { useEffect, useState } from "react";
import "./WaitingBubble.scss";
import { FastAvatar } from "@/Components/FastAvatar";

interface WaitingBubbleProps {
    senderName?: string;
    senderid?: string;
    senderAvatar?: string;
    onProfileClick?: () => void;
}

export default function WaitingBubble({ senderName, senderid, senderAvatar, onProfileClick }: WaitingBubbleProps) {
    const [dotIndex, setDotIndex] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setDotIndex((prev) => (prev + 1) % 7);
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="WaitingBubbleContainer">
            <div className="AvatarSpace">
                {senderid && (
                    <button type="button" className="AvatarButton" onClick={onProfileClick}>
                        <FastAvatar uri={senderAvatar} userid={senderid} size={32} style={{ borderRadius: '50%' }} />
                    </button>
                )}
            </div>
            <div className="BubbleContent">
                {senderName && (
                    <button type="button" className="SenderName" onClick={onProfileClick}>
                        {senderName}
                    </button>
                )}
                <div className="WaitingBubble">
                    <span className="WaitingDots">
                        <span className={`Dot ${dotIndex === 0 || dotIndex === 6 ? "Active" : ""}`}>.</span>
                        <span className={`Dot ${dotIndex === 1 || dotIndex === 5 ? "Active" : ""}`}>.</span>
                        <span className={`Dot ${dotIndex === 2 || dotIndex === 4 ? "Active" : ""}`}>.</span>
                        <span className={`Dot ${dotIndex === 3 ? "Active" : ""}`}>.</span>
                    </span>
                </div>
            </div>
        </div>
    );
}
